import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../Button/Button';
import './PublicHeader.css';
// @ts-ignore
import logoImage from '../../image-assets/logo.svg';

const PublicHeader: React.FC = () => {
  return (
    <header className="public-header">
      <div className="public-header-container">
        <div className="public-header-left">
          <Link to="/" className="public-logo-link">
            <img src={logoImage} alt="Texta Logo" className="public-logo-image" />
          </Link>
          <span className="public-header-title">Texta Feature Overview</span>
        </div>
        <div className="public-header-right">
          <Link to="/login">
            <Button variant="secondary" size="medium">Log In</Button>
          </Link>
          <Link to="/signup">
            <Button variant="primary" size="medium">Get Started</Button>
          </Link>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader; 